module.exports = __webpack_public_path__ + "img/loc.a44b8890.svg";